import { useMemo } from 'react';
import { VideoFile } from 'src/components/VideoPromotion';

const SORTED_VIDEO_TYPES = ['video/webm', 'video/mp4', undefined];

const useSortVideoFiles = (videoFiles: VideoFile[]) => {
  return useMemo(
    () =>
      videoFiles.slice().sort((first, second) => {
        const firstSortedIndex = SORTED_VIDEO_TYPES.indexOf(first.type);
        const secondSortedIndex = SORTED_VIDEO_TYPES.indexOf(second.type);

        if (firstSortedIndex < 0) {
          return 1;
        }
        return firstSortedIndex - secondSortedIndex;
      }),
    [videoFiles]
  );
};

export default useSortVideoFiles;
